import { render, staticRenderFns } from "./Presenze.vue?vue&type=template&id=c4f84532&"
import script from "./Presenze.vue?vue&type=script&lang=js&"
export * from "./Presenze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports